import { useCallback, useEffect, useRef, useState } from "react";
import { PageLocationTitle, StatusButton } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Swal from "sweetalert2";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { HistoryModal } from "src/components/atoms/historyModal";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import Navbar from "src/components/organisms/navbar";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CollapseText from "src/components/atoms/colapso-text";
import Highlighter from "react-highlight-words";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import RateReviewIcon from "@mui/icons-material/RateReview";
import { ShirtsModal } from "src/components/atoms/shirtsModal";

const SubscriptionAdm = () => {
  const location = useLocation();
  const tournamentsSearchState = location?.state?.selectedTournaments;
  const editedEnrollmentId = location?.state?.enrollmentId;
  const [data, setData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const { getToken } = useAuthenticate();
  const [visible, setVisible] = useState(false);
  const [tournaments, setTournaments] = useState<any>([]);
  const [tournamentMap, setTournamentMap] = useState<Record<number, any>>({});
  const [selectedTournaments, setSelectedTournaments] = useState<any[]>(
    tournamentsSearchState ? tournamentsSearchState : []
  );
  const [tournamentsSearch, setTournamentsSearch] = useState<number[]>(
    tournamentsSearchState
      ? tournamentsSearchState?.map((teste: any) => teste.id)
      : []
  );
  const [search, setSearch] = useState<string>(
    editedEnrollmentId ? editedEnrollmentId : ""
  );
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [historyData, setHistoryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [manualPayments, setManualPayments] = useState<any>([]);
  const [autoPayments, setAutoPayments] = useState<any>([]);
  const [paidSubs, setPaidSubs] = useState(0);
  const [unpaidSubs, setUnpaidSubs] = useState(0);
  const [searchPaymentStatus, setSearchPaymentStatus] = useState<string>("");
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [showShirtsModal, setShowShirtsModal] = useState<boolean>(false);
  const [changeTournamentModal, setChangeTournamentModal] = useState(false);
  const [changeTournamentSubs, setChangeTournamentSubs] = useState<any>(null);
  const [changeTournamentTarget, setChangeTournamentTarget] = useState<number | "">("");
  const [changeTournamentNewValue, setChangeTournamentNewValue] = useState("");
  const [changeTournamentObservation, setChangeTournamentObservation] = useState("");
  const [changeTournamentLoading, setChangeTournamentLoading] = useState(false);
  const [reviewDialogOpen, setReviewDialogOpen] = useState(false);
  const [reviewTarget, setReviewTarget] = useState<any>(null);
  const [reviewLoading, setReviewLoading] = useState(false);
  const url = window.location.pathname;

  const navigate = useNavigate();

  const handleEditFighter = (fighterId: number, slug: string) => {
    Swal.fire({
      title: "Como deseja editar sua inscrição?",
      text: "Você pode editar seguindo as regras do evento ou livremente.",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonColor: "#373737",
      confirmButtonText: "Editar com regras",
      denyButtonText: "Editar sem regras",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed)
        navigate(`/enrollment-update/${fighterId}/${slug}`, {
          state: {
            from: url,
            mode: "regras",
            selectedTournaments: selectedTournaments,
          },
        });
      else if (result.isDenied)
        navigate(`/enrollment-update/${fighterId}/${slug}`, {
          state: {
            from: url,
            mode: "livre",
            selectedTournaments: selectedTournaments,
          },
        });
    });
  };

  const changePayments = (id: any, status: any) => {
    Swal.fire({
      title: "Tem certeza que deseja mudar a status de pagamento?",
      icon: "warning",
      showDenyButton: true,
      showCancelButton: false,
      html:
        '<input type="text" id="paymentAmount" placeholder="Digite o valor do pagamento (ex: 150.00)" class="swal2-input" inputmode="decimal" required>' +
        '<input type="text" id="paymentObservation" placeholder="Observação (opcional)" class="swal2-input">',
      confirmButtonText: "Sim",
      denyButtonText: "Não",
      didOpen: () => {
        const input = document.getElementById("paymentAmount") as HTMLInputElement;
        if (input) {
          input.addEventListener("input", () => {
            input.value = input.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
          });
        }
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        const paymentAmountInput = document.getElementById(
          "paymentAmount"
        ) as HTMLInputElement;
        const paymentObservationInput = document.getElementById(
          "paymentObservation"
        ) as HTMLInputElement;

        if (paymentAmountInput && paymentAmountInput.checkValidity()) {
          const paymentAmount = paymentAmountInput.value;
          const observation = paymentObservationInput?.value || undefined;

          await api
            .patch(
              `/manager/payments/${id}`,
              {
                status: !status,
                valueSubscription: paymentAmount,
                ...(observation && { observation }),
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getToken()}`,
                },
              }
            )
            .then((response) => {
              if (response.status === 200) {
                const newList: any = data.map((item: any) => {
                  if (item.id === id) {
                    const updatedItem = {
                      ...item,
                      status: !item.status,
                      valueSubscription: paymentAmount,
                      observation: observation || item.observation,
                    };

                    return updatedItem;
                  }

                  return item;
                });

                setData(newList);
                getPaymentsInfo(
                  selectedTournaments.map((item: any) => item.id)
                );
                toast.success("Status de pagamento alterado com sucesso!");
              } else {
                toast.error("Não foi possível mudar status de pagamento!");
              }
            })
            .catch(() =>
              toast.error("Não foi possível mudar status de pagamento!")
            );
        } else {
          toast.error("Status não alterado, informe o valor de pagamento");
        }
      }
    });
  };

  const fetchSubs = useCallback(
    async (
      pageNumber = 1,
      tournaments: number[] = [],
      append = false,
      search = "",
      paymentStatus = ""
    ) => {
      setIsLoaded(false);

      if (tournaments.length === 0) {
        return;
      }

      if (loadingMore) return;
      setLoadingMore(true);

      try {
        const response = await api.get(
          `/administrators/tournaments/enrollments?${new URLSearchParams({
            page: pageNumber.toString(),
            limit: "250",
            tournaments: tournaments?.join(","),
            search: search,
            paymentStatus: paymentStatus,
          })}`,
          {
            headers: { Authorization: `Bearer ${getToken()}` },
          }
        );

        const newSubs = response.data.subscriptions;
        setData((prev: any) => (append ? [...prev, ...newSubs] : newSubs));
        setPage(+response.data.meta.page);
        setTotal(response.data.meta.total);
        setLastPage(response.data.meta.lastPage);
      } catch (error: any) {
        console.log(error);
        toast.error(
          error.response?.data?.message || "Erro ao carregar suas inscrições"
        );
      } finally {
        setInitialLoading(false);
        if (search != "") setIsLoaded(true);
        setLoadingMore(false);
      }
    },
    [getToken, loadingMore]
  );

  const mountTournamentsSearch = () => {
    setLoadingMore(true);

    api
      .get("/managers/tournaments/info", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((response) => {
        const arr = response.data;
        const map: Record<number, any> = {};
        arr.forEach((t: any) => {
          map[t.id] = t;
        });

        setTournaments(arr);
        setTournamentMap(map);
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  const getPaymentsInfo = (tournamentIds: number[]) => {
    if (tournamentIds.length === 0) {
      return;
    }

    api
      .get(`/administrators/tournaments/payment/infos/${tournamentIds}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((response) => {
        setUnpaidSubs(response.data.totalUnpaid);
        setPaidSubs(response.data.totalPaid);
        setManualPayments(response.data.resultManual);
        setAutoPayments(response.data.resultAuto);
      });
  };

  const showHistorySubsModal = async (subscriptionId: number) => {
    await api
      .get(`/history/Subscription/${subscriptionId}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((res) => {
        setHistoryData(res.data);
        setIsModalOpen(true);
      });
  };

  const handleOpenChangeTournament = (subs: any) => {
    setChangeTournamentSubs(subs);
    setChangeTournamentTarget("");
    setChangeTournamentNewValue(subs.valueSubscription || "");
    setChangeTournamentObservation("");
    setChangeTournamentModal(true);
  };

  const handleCloseChangeTournament = () => {
    setChangeTournamentModal(false);
    setChangeTournamentSubs(null);
  };

  const handleOpenReviewDialog = (subs: any) => {
    setReviewTarget(subs);
    setReviewDialogOpen(true);
  };

  const handleCloseReviewDialog = () => {
    setReviewDialogOpen(false);
    setReviewTarget(null);
  };

  const handleApproveReview = async (subsId: number) => {
    setReviewLoading(true);
    try {
      await api.patch(
        `/administrators/tournaments/enrollments/${subsId}/approve-review`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      toast.success("Alterações aprovadas com sucesso!");
      setData((prev: any) =>
        prev.map((item: any) =>
          item.id === subsId ? { ...item, needsReview: false, previousData: null } : item
        )
      );
      handleCloseReviewDialog();
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao aprovar alterações");
    } finally {
      setReviewLoading(false);
    }
  };

  const handleRejectReview = async (subsId: number) => {
    setReviewLoading(true);
    try {
      await api.patch(
        `/administrators/tournaments/enrollments/${subsId}/reject-review`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      toast.success("Alterações rejeitadas e valores revertidos!");
      // Recarregar inscrições para refletir reversão
      fetchSubs(1, tournamentsSearch, false, search, searchPaymentStatus);
      handleCloseReviewDialog();
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao rejeitar alterações");
    } finally {
      setReviewLoading(false);
    }
  };

  const reviewFieldLabels: Record<string, string> = {
    weight: "Peso",
    genre: "Gênero",
    age: "Idade",
    belt: "Faixa",
    category: "Categoria",
  };

  const handleConfirmChangeTournament = async () => {
    if (!changeTournamentTarget || !changeTournamentSubs) {
      toast.error("Selecione o torneio destino");
      return;
    }

    const oldValue = parseFloat(changeTournamentSubs.valueSubscription) || 0;
    const newValue = parseFloat(changeTournamentNewValue) || 0;
    const adjustment = (newValue - oldValue).toFixed(2);

    setChangeTournamentLoading(true);
    try {
      await api.patch(
        `/administrators/tournaments/enrollments/${changeTournamentSubs.id}/change-tournament`,
        {
          newTournamentId: changeTournamentTarget,
          valueAdjustment: adjustment,
          ...(changeTournamentObservation && { observation: changeTournamentObservation }),
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      toast.success("Modalidade alterada com sucesso!");
      handleCloseChangeTournament();
      fetchSubs(1, tournamentsSearch, false, search, searchPaymentStatus);
      getPaymentsInfo(tournamentsSearch);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Erro ao trocar modalidade"
      );
    } finally {
      setChangeTournamentLoading(false);
    }
  };

  const handleChangePaymentStatus = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setSearchPaymentStatus(newAlignment);
    fetchSubs(1, tournamentsSearch, false, search, newAlignment);
  };

  // VERSÃO QUE NORMALIZA NUMEROS COM STRINGS
  // const parseNumericValue = (value: string): number | null => {
  //   if (!value) return null;

  //   // 1. pega apenas a última parte numérica da string
  //   const match = value.match(/(\d+(?:[.,]\d+)?)/);
  //   if (!match) return null;

  //   // 2. normaliza (tira pontos de milhar, troca vírgula por ponto)
  //   const cleaned = match[0].replace(/\./g, "").replace(",", ".");
  //   const parsed = Number(cleaned);

  //   return isNaN(parsed) ? null : parsed;
  // };

  // ESSA VERSÃO NAO ACEITA NUMEROS COM STRINGS OU STRINGS COM NUMEROS, SOMENTE NUMEROS
  const parseNumericValue = (value: string): number | null => {
    if (!value) return null;

    // remove espaços extras
    const trimmed = value.trim();

    // ✅ só aceita se a string for APENAS número (com vírgula ou ponto)
    const match = trimmed.match(/^\d+(?:[.,]\d+)?$/);
    if (!match) return null;

    const cleaned = trimmed.replace(/\./g, "").replace(",", ".");
    const parsed = parseFloat(cleaned);

    return isNaN(parsed) ? null : parseFloat(parsed.toFixed(2));
  };

  const formatNumber = (occurrences: number, value: string) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const numericValue = parseNumericValue(value);

    if (numericValue !== null) {
      const total = occurrences * numericValue;
      return `${occurrences} - ${formatter.format(
        numericValue
      )} = ${formatter.format(total)}`;
    }

    return `${occurrences} - ${value}`;
  };

  const allOptions = { id: "all", name: "TODOS" };

  useEffect(() => {
    if (tournaments.length === 0) {
      mountTournamentsSearch();
    }
  }, []);

  useEffect(() => {
    if (tournamentsSearchState) {
      const formatedIds = tournamentsSearchState.map((teste: any) => teste.id);
      fetchSubs(1, formatedIds, true, search);
      getPaymentsInfo(formatedIds);
    }

    if (tournamentsSearchState) {
      navigate(location.pathname, { replace: true, state: {} }); // limpa o state no histórico
    }
  }, []);

  // observer para infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && page < lastPage && !initialLoading) {
          fetchSubs(
            page + 1,
            tournamentsSearch,
            true,
            search,
            searchPaymentStatus
          );
        }
      },
      { threshold: 0 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [page, lastPage, tournamentsSearch, fetchSubs, initialLoading]);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSearch = () => {
    fetchSubs(1, tournamentsSearch, false, search, searchPaymentStatus);
  };

  const handleShowShirtsModal = () => {
    setShowShirtsModal(true);
  };

  const handleCloseShirtsModal = () => {
    setShowShirtsModal(false);
  };

  return (
    <>
      <Navbar />
      <Container>
        <Box sx={{ mt: 2 }}>
          <PageLocationTitle>Gerenciar pagamentos</PageLocationTitle>
        </Box>

        {loadingMore && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center", // centraliza horizontalmente
              alignItems: "center", // centraliza verticalmente
              backdropFilter: "blur(6px)", // 👈 aplica o blur no fundo
              backgroundColor: "rgba(255, 255, 255, 0.4)", // leve transparência
              zIndex: 2000, // garante que fica acima de tudo
              gap: 2,
            }}
          >
            <Typography
              sx={{ fontFamily: "Inter, sans-serif", fontSize: "1.1rem" }}
            >
              Aguarde, estamos carregando suas inscrições...
            </Typography>

            <CircularProgress sx={{ color: "black" }} />
          </Box>
        )}

        <Autocomplete
          multiple
          options={[...tournaments, allOptions]}
          getOptionLabel={(option) => option.name}
          value={selectedTournaments}
          defaultValue={tournamentsSearchState}
          onChange={(event, newValue) => {
            if (newValue.length === 0) {
              setTournamentsSearch([]);
              setSelectedTournaments([]);
              setAutoPayments([]);
              setManualPayments([]);
              setUnpaidSubs(0);
              setTotal(0);
              setPage(0);
              setPaidSubs(0);
              setData([]);
            }

            if (newValue.some((val) => val.id === "all")) {
              // se clicou em "Selecionar todos", marca todos
              const tounamentIds = tournaments.map((value: any) => value.id);
              setTournamentsSearch(tounamentIds);
              fetchSubs(1, tounamentIds, false, undefined, searchPaymentStatus);
              getPaymentsInfo(tounamentIds);
              setSelectedTournaments(tournaments);
            } else {
              const tounamentIds = newValue.map((value) => value.id);
              setTournamentsSearch(tounamentIds);
              setSelectedTournaments(newValue);
              fetchSubs(1, tounamentIds, false, undefined, searchPaymentStatus);
              getPaymentsInfo(tounamentIds);
            }
          }}
          renderValue={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                onClick={() => undefined}
                sx={{ cursor: "default" }}
                label={option.name}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Digite para buscar torneios..."
              variant="outlined"
              size="small"
              //error={selectedTournaments.length === 0}
              //helperText={selectedTournaments.length === 0 ? "Selecione pelo menos um torneio" : ""}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "white",
                },
              }}
            />
          )}
          filterOptions={(options, { inputValue }) => {
            return options.filter((option) =>
              option.name.toLowerCase().includes(inputValue.toLowerCase())
            );
          }}
          noOptionsText="Nenhum torneio encontrado"
          loadingText="Carregando torneios..."
          sx={{
            mt: 1,
            "& .MuiAutocomplete-paper": {
              backgroundColor: "white",
            },
          }}
        />

        <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              color: "rgb(132, 140, 155)",
              fontFamily: "inter, sans-serif",
            }}
          >
            {total} INSCRIÇÕES ENCONTRADAS
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              color: "rgb(132, 140, 155)",
              fontFamily: "inter, sans-serif",
            }}
          >
            {unpaidSubs} INSCRIÇÕES NÃO PAGAS
          </Typography>
          <CollapseText title={`${paidSubs} INSCRIÇÕES PAGAS`}>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "14px",
                color: "black",
                fontWeight: 700,
                fontFamily: "inter, sans-serif",
              }}
            >
              PAGAMENTOS MANUAIS
            </Typography>

            {manualPayments.length > 0 ? (
              <>
                {Object.values(
                  manualPayments.reduce((acc: any, item: any) => {
                    const numericValue = parseNumericValue(item.value);

                    // se for número → agrupa pelo número
                    if (numericValue !== null) {
                      if (!acc[numericValue]) {
                        acc[numericValue] = {
                          ...item,
                          value: numericValue,
                          occurrences: 0,
                        };
                      }
                      acc[numericValue].occurrences += item.occurrences;
                    } else {
                      // se for string → agrupa pelo texto original
                      if (!acc[item.value]) {
                        acc[item.value] = { ...item, occurrences: 0 };
                      }
                      acc[item.value].occurrences += item.occurrences;
                    }

                    return acc;
                  }, {})
                )
                  .sort((a: any, b: any) => b.occurrences - a.occurrences)
                  .map((item: any) => (
                    <Typography
                      key={`${item.occurrences}-${item.value}`}
                      variant="subtitle1"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "rgb(132, 140, 155)",
                        fontFamily: "inter, sans-serif",
                      }}
                    >
                      {formatNumber(item.occurrences, String(item.value))}
                    </Typography>
                  ))}

                {/* Total exibido apenas uma vez */}
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "black",
                    fontFamily: "inter, sans-serif",
                    mt: 1,
                  }}
                >
                  TOTAL:{" "}
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    manualPayments.reduce((acc: number, item: any) => {
                      const numericValue = parseNumericValue(item.value);
                      return numericValue !== null
                        ? acc + item.occurrences * numericValue
                        : acc;
                    }, 0)
                  )}
                </Typography>
              </>
            ) : (
              <Typography variant="subtitle2" sx={{ color: "black" }}>
                Nenhum pagamento encontrado
              </Typography>
            )}

            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "14px",
                color: "black",
                fontWeight: 700,
                fontFamily: "inter, sans-serif",
                mt: 1,
              }}
            >
              PAGAMENTOS AUTOMÁTICOS
            </Typography>

            {autoPayments.length > 0 ? (
              <>
                {Object.values(
                  autoPayments.reduce((acc: any, item: any) => {
                    const numericValue = parseNumericValue(item.value);

                    // se for número → agrupa pelo número
                    if (numericValue !== null) {
                      if (!acc[numericValue]) {
                        acc[numericValue] = {
                          ...item,
                          value: numericValue,
                          occurrences: 0,
                        };
                      }
                      acc[numericValue].occurrences += item.occurrences;
                    } else {
                      // se for string → agrupa pelo texto original
                      if (!acc[item.value]) {
                        acc[item.value] = { ...item, occurrences: 0 };
                      }
                      acc[item.value].occurrences += item.occurrences;
                    }

                    return acc;
                  }, {})
                )
                  .sort((a: any, b: any) => b.occurrences - a.occurrences)
                  .map((item: any) => (
                    <Typography
                      key={`${item.occurrences}-${item.value}`}
                      variant="subtitle1"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "rgb(132, 140, 155)",
                        fontFamily: "inter, sans-serif",
                      }}
                    >
                      {formatNumber(item.occurrences, String(item.value))}
                    </Typography>
                  ))}

                {/* Total exibido apenas uma vez */}
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "black",
                    fontFamily: "inter, sans-serif",
                    mt: 1,
                  }}
                >
                  TOTAL:{" "}
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    autoPayments.reduce((acc: number, item: any) => {
                      const numericValue = parseNumericValue(item.value);
                      return numericValue !== null
                        ? acc + item.occurrences * numericValue
                        : acc;
                    }, 0)
                  )}
                </Typography>
              </>
            ) : (
              <Typography variant="subtitle2" sx={{ color: "black" }}>
                Nenhum pagamento encontrado
              </Typography>
            )}

            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "14px",
                color: "black",
                fontWeight: 700,
                fontFamily: "inter, sans-serif",
                mt: 1,
              }}
            >
              PAGAMENTOS TOTAIS
            </Typography>

            {[...manualPayments, ...autoPayments].length > 0 ? (
              <>
                {Object.values(
                  [...manualPayments, ...autoPayments].reduce(
                    (acc: any, item: any) => {
                      const numericValue = parseNumericValue(item.value);

                      // se for número → agrupa pelo número
                      if (numericValue !== null) {
                        if (!acc[numericValue]) {
                          acc[numericValue] = {
                            ...item,
                            value: numericValue,
                            occurrences: 0,
                          };
                        }
                        acc[numericValue].occurrences += item.occurrences;
                      } else {
                        // se for string → agrupa pelo texto original
                        if (!acc[item.value]) {
                          acc[item.value] = { ...item, occurrences: 0 };
                        }
                        acc[item.value].occurrences += item.occurrences;
                      }

                      return acc;
                    },
                    {}
                  )
                )
                  .sort((a: any, b: any) => b.occurrences - a.occurrences)
                  .map((item: any) => (
                    <Typography
                      key={`all-${item.occurrences}-${item.value}`}
                      variant="subtitle1"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "rgb(132, 140, 155)",
                        fontFamily: "inter, sans-serif",
                      }}
                    >
                      {formatNumber(item.occurrences, String(item.value))}
                    </Typography>
                  ))}

                {/* Total exibido apenas uma vez */}
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "black",
                    fontFamily: "inter, sans-serif",
                    mt: 1,
                  }}
                >
                  TOTAL:{" "}
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    [...manualPayments, ...autoPayments].reduce(
                      (acc: number, item: any) => {
                        const numericValue = parseNumericValue(item.value);
                        return numericValue !== null
                          ? acc + item.occurrences * numericValue
                          : acc;
                      },
                      0
                    )
                  )}
                </Typography>
              </>
            ) : (
              <Typography variant="subtitle2" sx={{ color: "black" }}>
                Nenhum pagamento encontrado
              </Typography>
            )}
          </CollapseText>
        </Box>

        <Box sx={{ display: "flex", mt: 1 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Digite nome, academia, faixa, categoria..."
            value={search}
            defaultValue={editedEnrollmentId ? editedEnrollmentId : ""}
            onChange={(e) => {
              if (e.target.value === "") {
                setIsLoaded(false);
                fetchSubs(
                  1,
                  tournamentsSearch,
                  false,
                  undefined,
                  searchPaymentStatus
                );
              }
              setSearch(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearch();
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={handleSearch}>
                    <SearchIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box sx={{ display: "flex", mt: 2, gap: 2 }}>
          <ToggleButtonGroup
            color="standard"
            value={searchPaymentStatus}
            exclusive
            defaultValue={""}
            onChange={handleChangePaymentStatus}
            aria-label="Platform"
          >
            <ToggleButton value="">Todas</ToggleButton>
            <ToggleButton value="true">Pagas</ToggleButton>
            <ToggleButton value="false">Não pagas</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Button
          sx={{
            mt: 2,
            fontFamily: "inter, sans-serif",
            backgroundColor: "#373737",
            color: "white",
          }}
          onClick={() => handleShowShirtsModal()}
        >
          Relatório de camisas
        </Button>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          {data.map((subs: any) => {
            const tournamentInfo = tournamentMap[subs.tournamentId];
            return (
              <Paper
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" }, // <-- muda conforme tamanho
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", sm: "center" }, // ajusta alinhamento no mobile
                  gap: 2, // adiciona espaçamento entre colunas
                }}
              >
                {/* Coluna esquerda */}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    sx={{ fontFamily: "inter, sans-serif", fontWeight: 700 }}
                  >
                    {"Inscrição Nº "} {subs.id} - {tournamentInfo.name}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontFamily: "inter, sans-serif",
                        fontWeight: 700,
                        color: subs.status ? "green" : "red",
                      }}
                    >
                      <strong>Valor:</strong> R$ {subs.valueSubscription}
                    </Typography>
                    {subs.valueAdjustment && (
                      <Chip
                        label={
                          parseFloat(subs.valueAdjustment) > 0
                            ? `+R$ ${parseFloat(subs.valueAdjustment).toFixed(2)} cobrança`
                            : `−R$ ${Math.abs(parseFloat(subs.valueAdjustment)).toFixed(2)} reembolso`
                        }
                        size="small"
                        sx={{
                          backgroundColor:
                            parseFloat(subs.valueAdjustment) > 0 ? "#e8f5e9" : "#ffebee",
                          color:
                            parseFloat(subs.valueAdjustment) > 0 ? "#2e7d32" : "#c62828",
                          fontWeight: "bold",
                          fontFamily: "inter, sans-serif",
                          fontSize: "0.65rem",
                        }}
                      />
                    )}
                    <Chip
                      label={subs.paidAuto ? "AUTOMÁTICO" : "MANUAL"}
                      size="small"
                      sx={{
                        backgroundColor: subs.paidAuto ? "#e3f2fd" : "#fff3e0",
                        color: subs.paidAuto ? "#1565c0" : "#e65100",
                        fontWeight: "bold",
                        fontFamily: "inter, sans-serif",
                        fontSize: "0.65rem",
                      }}
                    />
                    {subs.needsReview && (
                      <Chip
                        icon={<RateReviewIcon sx={{ fontSize: "0.9rem" }} />}
                        label="PENDENTE DE REVISÃO"
                        size="small"
                        onClick={() => handleOpenReviewDialog(subs)}
                        sx={{
                          backgroundColor: "#fff8e1",
                          color: "#f57f17",
                          fontWeight: "bold",
                          fontFamily: "inter, sans-serif",
                          fontSize: "0.65rem",
                          cursor: "pointer",
                          border: "1px solid #ffcc02",
                        }}
                      />
                    )}
                  </Box>

                  <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      fontSize: "0.85rem",
                      color: "#666",
                    }}
                  >
                    <strong>Obs:</strong> {subs.observation || "Sem observação"}
                  </Typography>

                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Nome:</strong>{" "}
                    {isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={
                          subs.fighters
                            ? subs?.fighters?.name?.toUpperCase()
                            : subs?.user?.name?.toUpperCase()
                        }
                      />
                    ) : subs.fighters ? (
                      subs?.fighters?.name?.toUpperCase()
                    ) : (
                      subs?.user?.name?.toUpperCase()
                    )}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <strong>Contato:</strong>
                    <Link
                      href={`https://wa.me/${
                        subs.fighters
                          ? subs?.fighters?.phone?.replace(/\D/g, "")
                          : subs?.user?.phone?.replace(/\D/g, "")
                      }`} // remove tudo que não é número
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="none"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: "#2576d3ff",
                      }}
                    >
                      <WhatsAppIcon fontSize="small" />
                      {isLoaded ? (
                        <Highlighter
                          highlightClassName="highlight"
                          searchWords={[search]}
                          autoEscape={true}
                          textToHighlight={
                            subs.fighters
                              ? subs.fighters.phone
                              : subs.user.phone
                          }
                        />
                      ) : subs.fighters ? (
                        subs.fighters.phone
                      ) : (
                        subs.user.phone
                      )}
                    </Link>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Gênero: </strong>
                    {isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={subs.genre?.toUpperCase()}
                      />
                    ) : (
                      subs.genre?.toUpperCase()
                    )}
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Idade de luta:</strong>{" "}
                    {isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={subs.age + " anos"}
                      />
                    ) : (
                      subs.age + " anos"
                    )}
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Equipe:</strong>{" "}
                    {isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={
                          subs.fighters
                            ? subs?.fighters?.gym?.toLocaleUpperCase()
                            : subs?.user?.gym?.toLocaleUpperCase()
                        }
                      />
                    ) : subs.fighters ? (
                      subs?.fighters?.gym?.toLocaleUpperCase()
                    ) : (
                      subs?.user?.gym?.toLocaleUpperCase()
                    )}
                    <Typography
                    sx={{
                      fontFamily: "inter, sans-serif",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <strong>Contato do responsável:</strong>
                    <Link
                      href={`https://wa.me/55${subs?.user?.phone?.replace(
                        /\D/g,
                        ""
                      )}`} // remove tudo que não é número
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="none"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: "#2576d3ff",
                      }}
                    >
                      <WhatsAppIcon fontSize="small" />
                      {isLoaded ? (
                        <Highlighter
                          highlightClassName="highlight"
                          searchWords={[search]}
                          autoEscape={true}
                          textToHighlight={subs.user.phone}
                        />
                      ) : (
                        subs.user.phone
                      )}
                    </Link>
                  </Typography>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Categoria(s):</strong>{" "}
                    {isLoaded ? (
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={
                          subs.genre?.toUpperCase() +
                          ` (${subs?.category?.toUpperCase()})` +
                          ` / ${subs.belt?.toUpperCase()} / ${subs.weight?.toUpperCase()}`
                        }
                      />
                    ) : (
                      subs.genre?.toUpperCase() +
                      ` (${subs?.category?.toUpperCase()})` +
                      ` / ${subs.belt?.toUpperCase()} / ${subs.weight?.toUpperCase()}`
                    )}
                  </Typography>

                  {subs.tShirts && (
                    <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                      <strong>Camisa:</strong>{" "}
                      {subs.tShirts.measure?.toLocaleUpperCase()} (
                      {subs.tShirts?.size.toLocaleUpperCase()}) -{" "}
                      {subs.tShirts.color?.toLocaleUpperCase()} -{" "}
                      {subs?.tShirts?.price === 999
                        ? "Grátis"
                        : `R$${subs?.tShirts?.price}`}
                    </Typography>
                  )}

                  {subs.championGuarantee && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                        <strong>Garantia campeã</strong> -{" "}
                        {`R$${subs.priceChampionGuarantee}`}
                      </Typography>
                      <Tooltip
                        title="Este usuário adquiriu a garantia campeã!"
                        arrow
                      >
                        <EmojiEventsIcon color="warning" />
                      </Tooltip>
                    </Box>
                  )}
                </Box>

                {/* Coluna direita */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: { xs: "flex-start", sm: "flex-end" },
                    gap: 1,
                    mt: { xl: -20, xs: 0, sm: 0 },
                    width: { xs: "100%", sm: "auto" }, // botão ocupa toda a largura no celular
                    flexWrap: "wrap", // previne estouro em telas muito pequenas
                  }}
                >
                  {subs.needsReview && (
                    <>
                      <Tooltip title="Aprovar alterações" arrow>
                        <CheckCircleOutlineIcon
                          sx={{ cursor: "pointer", color: "#2e7d32" }}
                          onClick={() => handleOpenReviewDialog(subs)}
                        />
                      </Tooltip>
                      <Tooltip title="Rejeitar alterações (reverter)" arrow>
                        <CancelOutlinedIcon
                          sx={{ cursor: "pointer", color: "#c62828" }}
                          onClick={() => {
                            Swal.fire({
                              title: "Rejeitar alterações?",
                              text: "Os dados serão revertidos para os valores anteriores.",
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#c62828",
                              confirmButtonText: "Sim, rejeitar",
                              cancelButtonText: "Cancelar",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                handleRejectReview(subs.id);
                              }
                            });
                          }}
                        />
                      </Tooltip>
                    </>
                  )}

                  <Tooltip title="Editar inscrição" arrow>
                    <EditIcon
                      sx={{ cursor: "pointer" }}
                      onClick={() =>
                        handleEditFighter(subs.id, tournamentInfo.slug)
                      }
                    />
                  </Tooltip>

                  <Tooltip title="Trocar modalidade (GI/NOGI)" arrow>
                    <SwapHorizIcon
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleOpenChangeTournament(subs)}
                    />
                  </Tooltip>

                  <Tooltip title="Histórico de alterações" arrow>
                    <HistoryIcon
                      sx={{ cursor: "pointer" }}
                      onClick={() => showHistorySubsModal(subs.id)}
                    />
                  </Tooltip>

                  <Tooltip title="Clique para mudar o status" arrow>
                    <StatusButton
                      role="button"
                      aria-disabled={subs.paidAuto}
                      status={subs.status}
                      onClick={() => changePayments(subs.id, subs.status)}
                    >
                      <span>
                        {subs.status
                          ? "Pagamento efetuado"
                          : "Pendente de pagamento"}
                      </span>
                    </StatusButton>
                  </Tooltip>
                </Box>
              </Paper>
            );
          })}
          <div ref={loaderRef} style={{ minHeight: 20 }} />
        </Box>
      </Container>
      <Zoom in={visible}>
        <Fab
          color="primary"
          size="medium"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            backgroundColor: "#373737",
            borderRadius: "50%",
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Zoom>

      <ShirtsModal
        showShirtsModal={showShirtsModal}
        handleCloseShirtsModal={handleCloseShirtsModal}
        tournaments={tournaments}
      />

      <HistoryModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        history={historyData}
        title="Inscrição"
        fieldLabels={{
          weight: "Peso",
          category: "Categoria",
          age: "Idade",
          belt: "Faixa",
        }}
        hiddenFields={[
          "tournamentId",
          "valueSubscription",
          "combo_subscription",
          "userId",
          "genre",
          "fightersId",
          "status",
        ]}
      />

      <Dialog
        open={changeTournamentModal}
        onClose={handleCloseChangeTournament}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontFamily: "inter, sans-serif", fontWeight: 700 }}>
          Trocar Modalidade / Torneio
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          {changeTournamentSubs && (() => {
            const oldValue = parseFloat(changeTournamentSubs.valueSubscription) || 0;
            const newValue = parseFloat(changeTournamentNewValue) || 0;
            const diff = newValue - oldValue;

            return (
              <>
                <Box sx={{ backgroundColor: "#f5f5f5", p: 2, borderRadius: 1 }}>
                  <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Inscrição Nº:</strong> {changeTournamentSubs.id}
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Atleta:</strong>{" "}
                    {changeTournamentSubs.fighters
                      ? changeTournamentSubs.fighters.name?.toUpperCase()
                      : changeTournamentSubs.user?.name?.toUpperCase()}
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                    <strong>Torneio atual:</strong>{" "}
                    {tournamentMap[changeTournamentSubs.tournamentId]?.name}
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif", fontWeight: 700 }}>
                    <strong>Valor pago:</strong> R$ {oldValue.toFixed(2)}
                  </Typography>
                </Box>

                <Autocomplete
                  options={tournaments.filter(
                    (t: any) => Number(t.id) !== Number(changeTournamentSubs.tournamentId)
                  )}
                  getOptionLabel={(option: any) => option.name}
                  value={
                    tournaments.find((t: any) => t.id === changeTournamentTarget) ||
                    null
                  }
                  onChange={(_e, newValue) =>
                    setChangeTournamentTarget(newValue ? newValue.id : "")
                  }
                  filterOptions={(options, { inputValue }) =>
                    options.filter((option: any) =>
                      option.name.toLowerCase().includes(inputValue.toLowerCase())
                    )
                  }
                  noOptionsText="Nenhum torneio encontrado"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Torneio destino"
                      placeholder="Digite para buscar..."
                      variant="outlined"
                      size="small"
                    />
                  )}
                  sx={{ mt: 1 }}
                />

                <TextField
                  label="Novo valor da inscrição"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={changeTournamentNewValue}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                    setChangeTournamentNewValue(val);
                  }}
                  inputProps={{ inputMode: "decimal" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">R$</InputAdornment>
                    ),
                  }}
                />

                {changeTournamentNewValue && (
                  <Box
                    sx={{
                      backgroundColor: diff > 0 ? "#e8f5e9" : diff < 0 ? "#ffebee" : "#f5f5f5",
                      p: 1.5,
                      borderRadius: 1,
                      border: "1px solid",
                      borderColor: diff > 0 ? "#a5d6a7" : diff < 0 ? "#ef9a9a" : "#e0e0e0",
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                        Valor pago
                      </Typography>
                      <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                        R$ {oldValue.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                        Novo valor
                      </Typography>
                      <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif", fontWeight: 700 }}>
                        R$ {newValue.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderTop: "1px solid",
                        borderColor: diff > 0 ? "#a5d6a7" : diff < 0 ? "#ef9a9a" : "#e0e0e0",
                        mt: 1,
                        pt: 1,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: "inter, sans-serif",
                          fontWeight: 700,
                          color: diff > 0 ? "#2e7d32" : diff < 0 ? "#c62828" : "#666",
                        }}
                      >
                        {diff > 0 ? "Cobrança adicional" : diff < 0 ? "Reembolso" : "Sem diferença"}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: "inter, sans-serif",
                          fontWeight: 700,
                          color: diff > 0 ? "#2e7d32" : diff < 0 ? "#c62828" : "#666",
                        }}
                      >
                        {diff !== 0 ? `R$ ${Math.abs(diff).toFixed(2)}` : "—"}
                      </Typography>
                    </Box>
                  </Box>
                )}

                <TextField
                  label="Observação (opcional)"
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  rows={2}
                  value={changeTournamentObservation}
                  onChange={(e) => setChangeTournamentObservation(e.target.value)}
                />
              </>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseChangeTournament}
            sx={{ color: "#666", fontFamily: "inter, sans-serif" }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmChangeTournament}
            disabled={changeTournamentLoading || !changeTournamentTarget}
            variant="contained"
            sx={{
              backgroundColor: "#373737",
              fontFamily: "inter, sans-serif",
              "&:hover": { backgroundColor: "#4a4a4a" },
            }}
          >
            {changeTournamentLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              "Confirmar troca"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de revisão de alterações */}
      <Dialog
        open={reviewDialogOpen}
        onClose={handleCloseReviewDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontFamily: "inter, sans-serif", fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
          <RateReviewIcon sx={{ color: "#f57f17" }} />
          Revisar Alterações
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          {reviewTarget && (
            <>
              <Box sx={{ backgroundColor: "#f5f5f5", p: 2, borderRadius: 1 }}>
                <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                  <strong>Inscrição Nº:</strong> {reviewTarget.id}
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                  <strong>Atleta:</strong>{" "}
                  {reviewTarget.fighters
                    ? reviewTarget.fighters.name?.toUpperCase()
                    : reviewTarget.user?.name?.toUpperCase()}
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: "inter, sans-serif" }}>
                  <strong>Torneio:</strong>{" "}
                  {tournamentMap[reviewTarget.tournamentId]?.name}
                </Typography>
              </Box>

              <Typography
                variant="subtitle2"
                sx={{ fontFamily: "inter, sans-serif", fontWeight: 700, mt: 1 }}
              >
                Alterações solicitadas pelo atleta:
              </Typography>

              {reviewTarget.previousData && typeof reviewTarget.previousData === "object" ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {Object.entries(reviewTarget.previousData as Record<string, string>).map(
                    ([field, oldValue]) => {
                      const currentValue = reviewTarget[field] || "";
                      const changed = oldValue !== currentValue;
                      if (!changed) return null;
                      return (
                        <Box
                          key={field}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 1.5,
                            borderRadius: 1,
                            backgroundColor: "#fff3e0",
                            border: "1px solid #ffe0b2",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontFamily: "inter, sans-serif", fontWeight: 700 }}
                          >
                            {reviewFieldLabels[field] || field}
                          </Typography>
                          <Box sx={{ textAlign: "right" }}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontFamily: "inter, sans-serif",
                                color: "#c62828",
                                textDecoration: "line-through",
                              }}
                            >
                              {String(oldValue).toUpperCase() || "(vazio)"}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontFamily: "inter, sans-serif",
                                color: "#2e7d32",
                                fontWeight: 700,
                              }}
                            >
                              {String(currentValue).toUpperCase() || "(vazio)"}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    }
                  )}
                </Box>
              ) : (
                <Typography variant="body2" sx={{ color: "#666" }}>
                  Dados anteriores não disponíveis
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleCloseReviewDialog}
            sx={{ color: "#666", fontFamily: "inter, sans-serif" }}
          >
            Fechar
          </Button>
          <Button
            onClick={() => reviewTarget && handleRejectReview(reviewTarget.id)}
            disabled={reviewLoading}
            variant="outlined"
            sx={{
              borderColor: "#c62828",
              color: "#c62828",
              fontFamily: "inter, sans-serif",
              "&:hover": { borderColor: "#b71c1c", backgroundColor: "#ffebee" },
            }}
          >
            {reviewLoading ? <CircularProgress size={20} /> : "Rejeitar"}
          </Button>
          <Button
            onClick={() => reviewTarget && handleApproveReview(reviewTarget.id)}
            disabled={reviewLoading}
            variant="contained"
            sx={{
              backgroundColor: "#2e7d32",
              fontFamily: "inter, sans-serif",
              "&:hover": { backgroundColor: "#1b5e20" },
            }}
          >
            {reviewLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              "Aprovar"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubscriptionAdm;
